<span class="d-inline-block text-left" [hidden]="actionButtons.length == 0">
    <a *ngFor="let item of actionButtons" (click)="onUserAction(item)" [hidden]="item.isHidden"
    [ngClass]="item.class"
        class="text-underline a-setup" style="text-decoration: underline;">{{item.text}}  
        <em class="padding-left-15 fas fa-check-circle f-20 icon-Green" *ngIf="item.showGreenTick"></em>      
    </a>            
</span>
